/**
 * Quill Initialization Utility
 *
 * Exports the Quill 2.0 constructor from react-quill-new.
 */

import { Quill } from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

// Ensure Quill is available globally
if (typeof window !== "undefined") {
  window.Quill = Quill;
}

// BlotFormatter is registered via ensureBlotFormatter.js

export default Quill;
